import * as Yup from "yup";
import { getPatchOperations } from "../../../util/form";

export const adminKodelisteSanktionstypeForm = (
  kodelisteQueryType: KodelisteQueryType,
  nameList: string[],
  nr?: number,
): FormConfig<KodelisteSanktionstypeDTO> => {
  return {
    title: "Sanktionstype",
    lockedValues: [{ id: "nr", value: nr }],
    validationSchema: Yup.object({
      navn: Yup.string()
        .test("nameExistsTest", "Dette navn findes allerede", function () {
          return !nameList.some((name) => name === this.parent.navn);
        })
        .required("Kan ikke oprettes uden et navn"),
      udvidetLevetid: Yup.boolean(),
      deaktiveret: Yup.boolean(),
    }),
    form: [
      {
        component: "textinput",
        id: "navn",
        initialValue: "",
        label: "Navn",
        placeholder: " ",
        isRequired: true,
      },
      {
        component: "boolean",
        id: "udvidetLevetid",
        initialValue: false,
        label: "Udvidet levetid",
      },
      {
        component: "boolean",
        id: "deaktiveret",
        initialValue: false,
        label: "Deaktiveret",
      },
    ],
    get: `kodelister/${kodelisteQueryType}/${nr}`,
    post(values) {
      return {
        query: `kodelister/${kodelisteQueryType}`,
        body: values,
      };
    },
    patch(values) {
      return {
        query: `kodelister/${kodelisteQueryType}/${nr}`,
        body: JSON.stringify(getPatchOperations(values)),
      };
    },
    delete() {
      return {
        query: `kodelister/${kodelisteQueryType}/${nr}`,
      };
    },
  };
};
